import { render, staticRenderFns } from "./OrderSummaryTab.vue?vue&type=template&id=d27458fe&"
import script from "./OrderSummaryTab.vue?vue&type=script&lang=js&"
export * from "./OrderSummaryTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports